import React, { useState } from "react"
import { Link, NavLink } from "react-router-dom"
import FxTicker from "../Ticker/FxTicker"

// Iconos sencillos para el menú hamburguesa
const MenuIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 6h16M4 12h16M4 18h16"
    />
  </svg>
)

const CloseIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
)

export default function Header() {
  // 1. Estado para controlar si el menú móvil está abierto
  const [isOpen, setIsOpen] = useState(false)

  // Función para cerrar el menú (útil después de hacer clic en un enlace)
  const closeMenu = () => setIsOpen(false)

  // Sub-componente LinkItem (se mantiene igual)
  const LinkItem = ({ to, children, isMobile = false }) => (
    <NavLink
      to={to}
      onClick={isMobile ? closeMenu : undefined} // Cierra el menú móvil al hacer clic
      className={({ isActive }) =>
        `px-4 py-2 rounded-lg transition-all duration-300 font-medium ${
          // Clases específicas para el menú móvil o de escritorio
          isMobile
            ? `block w-full text-left ${
                isActive
                  ? "text-white bg-indigo-600 font-semibold"
                  : "text-slate-700 hover:text-indigo-700 hover:bg-indigo-50"
              }`
            : `hover:bg-indigo-50 border border-transparent hover:border-indigo-100 ${
                isActive
                  ? "text-white bg-gradient-to-r from-indigo-600 to-purple-600 shadow-lg shadow-indigo-500/25 font-semibold"
                  : "text-slate-700 hover:text-indigo-700"
              }`
        }`
      }
    >
      {children}
    </NavLink>
  )

  return (
    <header className="bg-white border-b border-slate-200 shadow-sm">
      {/* Franja de tasas (FxTicker) */}
      {/* <div className="bg-indigo-600 text-white text-sm">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center h-9 w-full">
            <div className="w-full">
              <FxTicker />
            </div>
          </div>
        </div>
      </div> */}

      {/* Menú principal con logo */}
      <nav className="bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between py-4">
            {/* Logo a la izquierda */}
            <Link
              to="/"
              className="flex items-center space-x-3 group"
              onClick={closeMenu}
            >
              {/* ... Contenido del Logo ... */}
              <div className="flex items-center justify-center transition-all duration-300 group-hover:scale-105">
                <img
                  src="logoremove.png"
                  alt="QuipusMania"
                  className="h-16 w-auto max-w-32 object-contain"
                  onError={(e) => {
                    e.target.style.display = "none"
                    e.target.nextSibling.style.display = "flex"
                  }}
                />
                <div className="h-12 w-12 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-xl flex items-center justify-center shadow-lg shadow-indigo-500/30 hidden">
                  <span className="text-white font-bold text-lg">Q</span>
                </div>
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-xl text-slate-800 leading-5">
                  QuipusMania
                </span>
                <span className="text-xs text-slate-500 leading-3">
                  Encuentra y compara
                </span>
              </div>
            </Link>

            {/* Menú centrado - VISIBLE SOLO EN PANTALLAS GRANDES (lg:flex) */}
            <div className="hidden lg:flex items-center space-x-1 bg-gray-50/80 rounded-2xl px-2 py-1 border border-gray-100 shadow-sm">
              <LinkItem to="/">Inicio</LinkItem>
              <LinkItem to="/productos">Productos</LinkItem>
              <LinkItem to="/quienes-somos">Quiénes somos</LinkItem>
              <LinkItem to="/contacto">Contacto</LinkItem>
            </div>

            {/* Botón hamburguesa - VISIBLE SOLO EN PANTALLAS PEQUEÑAS (lg:hidden) */}
            <div className="flex items-center lg:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="p-2 text-slate-700 hover:text-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 rounded-lg transition duration-150"
                aria-label="Toggle Menu"
              >
                {isOpen ? <CloseIcon /> : <MenuIcon />}
              </button>
            </div>

            {/* Espacio a la derecha (Botón Afiliar) - Se mueve para estar a la derecha en escritorio */}
            <div className="hidden lg:block">
              <a
                href="https://panel.quipusmania.com/signin"
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-lg font-medium hover:shadow-lg hover:shadow-amber-500/25 transition-all duration-300 text-sm"
              >
                Afiliar comercio
              </a>
            </div>

            {/* Añadimos un div vacío para mantener la alineación cuando el botón hamburguesa está visible */}
            <div className="lg:hidden w-10"></div>
          </div>
        </div>

        {/* 3. Menú desplegable para móviles - Aparece condicionalmente */}
        <div
          className={`lg:hidden transition-all ease-in-out duration-300 overflow-hidden ${
            isOpen ? "max-h-96 opacity-100 py-3" : "max-h-0 opacity-0"
          }`}
        >
          <div className="flex flex-col space-y-1 px-4">
            <LinkItem to="/" isMobile={true}>
              Inicio
            </LinkItem>
            <LinkItem to="/productos" isMobile={true}>
              Productos
            </LinkItem>
            <LinkItem to="/quienes-somos" isMobile={true}>
              Quiénes somos
            </LinkItem>
            <LinkItem to="/contacto" isMobile={true}>
              Contacto
            </LinkItem>

            {/* Botón de acción para móvil */}
            <a
              href="https://panel.quipusmania.com/signin"
              onClick={closeMenu}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 px-4 py-2 text-center bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-lg font-medium hover:opacity-90 transition-opacity duration-300 text-base"
            >
              Afiliar comercio
            </a>
          </div>
        </div>
      </nav>
    </header>
  )
}
